export var Lang;
(function (Lang) {
    Lang["ZH_CN"] = "zh-CN";
    Lang["ZH_TW"] = "zh-TW";
    Lang["EN"] = "en"; // 英文
})(Lang || (Lang = {}));
//# sourceMappingURL=types.js.map